import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()
export class AgendaService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.agenda.listUrl, ServiceConfig.agenda.detailUrl);
  }
}



// WEBPACK FOOTER //
// ./src/services/agenda.service.ts